import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, Typography, useMediaQuery } from "@material-ui/core";
import { useIntl } from "react-intl";
import { BuyoutSearchBar } from "./BuyoutSearchBar";
import { messages } from "../messages";
import useBuyoutStyles from "../BuyoutStyles";
const BuyoutHeader = (props) => {
    const { hasApplications, searchFilter } = props;
    const intl = useIntl();
    const classes = useBuyoutStyles();
    const isMobile = useMediaQuery("(max-width:600px)");
    return (_jsxs(Grid, { container: true, spacing: isMobile ? 1 : 2, alignItems: "center", justifyContent: "space-between", children: [_jsx(Grid, { item: true, children: _jsx(Typography, { gutterBottom: true, className: classes.headerTitle, children: intl.formatMessage(messages.headerTitle) }) }), hasApplications && (_jsx(Grid, { item: true, style: { width: isMobile ? "100%" : "auto" }, children: _jsx(BuyoutSearchBar, { searchFilter: searchFilter, id: { name: "id" } }) }))] }));
};
export { BuyoutHeader };
//# sourceMappingURL=BuyoutHeader.js.map